import { render, staticRenderFns } from "./memberInfo.vue?vue&type=template&id=0bfcb355&scoped=true&"
import script from "./memberInfo.vue?vue&type=script&lang=js&"
export * from "./memberInfo.vue?vue&type=script&lang=js&"
import style0 from "./memberInfo.vue?vue&type=style&index=0&id=0bfcb355&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfcb355",
  null
  
)

export default component.exports